import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

export const useAddInstallationDocuments = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationFn: mutations.addMaterialInstallationDocuments,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useAddInstallationDocuments')
        .extras({errorDetails})
        .error('Error occurred while adding material installation attachment')

      spawnErrorToast(t('error.addMaterialInstallationDocuments'))
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['materialInstallationDetails']})
      await queryClient.invalidateQueries({queryKey: ['attachedDocumentsFiles']})
      await queryClient.invalidateQueries({queryKey: ['kilnReplacement']})
      spawnSuccessToast(t('success.addMaterialInstallationDocuments'))
    }
  })
}
